import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
        computed,
        ComputedRef
    } from 'vue'
    import {
        IBoardStyling
    } from '@/interfaces'
    import score from '@/store/score'
    import time from '@/store/time'
    import strikes from '@/store/strikes'
    import status from '@/store/status'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const styling: ComputedRef<IBoardStyling> = computed(() => {
        const red: boolean = status.hasLost
        const green: boolean = status.hasWon
        const blue: boolean = !red && !green
        const stylingObject: IBoardStyling = {
            red,
            green,
            blue
        }

        return stylingObject
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_unref(styling))
  }, [
    _createElementVNode("article", null, " Strikes: " + _toDisplayString(_unref(strikes).value), 1),
    _createElementVNode("article", null, " Time: " + _toDisplayString(_unref(time).value) + "s ", 1),
    _createElementVNode("article", null, " Score: " + _toDisplayString(_unref(score).value), 1)
  ], 2))
}
}

})